import {
    Typography, TextField, FormControl, InputLabel,
    OutlinedInput, InputAdornment, IconButton, FormGroup, Button, Link
} from '@mui/material';
import { Box } from '@mui/system';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import axios from 'axios';
import React, { useState } from 'react';
import { useAuth } from './utils/Auth';
import { useSnackbar } from 'notistack';

const style = {
    width: 'auto',
    '@media screen and (min-width:450px)': { width: 350 },
    margin: ' 0 auto',
    bgcolor: 'white',
    border: '2px solid #000',
    p: 4,
    textAlign: 'center'
};

export default function Login() {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const auth = useAuth();

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const user = {
            username: username,
            password: password
        };

        axios.post("https://inlinetracking.com/wp-json/inline-tracking/v1/route/login", user)
            .then(response => response.data)
            .then(data => {
                Window.nonce = data._wn;
                auth.login(data);
            })
            .catch(error => {
                enqueueSnackbar(error.response.data.message, { variant: 'error', autoHideDuration: 6000 });
            });
    };

    return (
        <Box sx={style} component="form" onSubmit={handleSubmit} >
            <Typography id="sign-in" variant="h4" component="h2">
                Sign In
            </Typography>
            <FormGroup id="transition-modal-description" sx={{ mt: 2 }}>
                <TextField
                    label="Username"
                    id="outlined-start-adornment" margin="normal"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    required autoFocus
                />
                <FormControl margin='normal'>
                    <InputLabel>Password</InputLabel>
                    <OutlinedInput
                        label="Password"
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        autoComplete="on"
                        required
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </FormGroup>
            <Typography sx={{ float: 'left', mr: 2 }}>
                <Link href="https://inlinetracking.com/wp-login.php?action=lostpassword" variant="body2" target={'_blank'}>Forgot your password?</Link>
            </Typography>
            <br />
            <Button
                size="large" variant='contained' startIcon={<ExitToAppIcon />}
                type='submit' sx={{ float: 'right', margin: '10px' }}
            > Sign In
            </Button>
        </Box>
    )
}